import { Component, OnInit, ViewChild } from '@angular/core';
import { GridOptions } from 'ag-grid-community';
import { CeqTableComponent } from '../../../../ceq/common/ceq-table/ceq-table.component';
import { Product } from '../../../common/models/Product.Model';
import { UserLogin } from '../../../common/models/UserLogin.Model';
import { SettingsService } from '../../../../core/settings/settings.service';
import { TaxService } from '../../tax.service';
import { ViewChildRendered } from '../../../common/renders/view-child-rendered';
import { DeleteChildRendered } from '../../../common/renders/delete-child-rendered';

@Component({
  selector: 'app-certify-product-list',
  templateUrl: './certify-product-list.component.html',
  styleUrls: ['./certify-product-list.component.scss']
})
export class CertifyProductListComponent implements OnInit {

  @ViewChild('CeqGrid', { static: false }) ceqGrid: CeqTableComponent;

  productName: string = '';
  productCode: string = '';
  user: UserLogin;
  pageSizes = [10, 50, 100, 1000, 'Todos'];
  pageSize: any = 100;

  constructor(
    private settings: SettingsService,
    private taxService: TaxService
  ) {
    this.user = this.settings.getUser();
  }

  gridOptions: GridOptions = {
    context: this,
    frameworkComponents: {
      viewChildRendered: ViewChildRendered,
      childDeleteMessageRenderer: DeleteChildRendered
    },
    suppressHorizontalScroll: true,
    onRowDoubleClicked(event: any) { },
    icons: {
      sortAscending: '<i class="fa fa-sort-up" style="margin-left:10px"></i>',
      sortDescending: '<i class="fa fa-sort-down" style="margin-left:10px"></i>',
      sortUnSort: '<i class="fa fa-sort" style="margin-left:10px"></i>'
    }
  };

  columnDefs = [
    {
      headerName: 'Código',
      field: 'ProductCode',
      width: 100,
      cellClass: 'text-right',
      sortable: true,
      resizable: true
    }, {
      headerName: 'Producto',
      field: 'ProductDescription',
      width: 250,
      cellClass: 'align-start',
      sortable: true,
      resizable: true
    }, {
      headerName: 'Descripción Corta',
      field: 'ProductName',
      width: 200,
      cellClass: 'align-start',
      sortable: true,
      resizable: true
    }, {
      headerName: 'Cupo',
      field: 'ProductConversion',
      width: 100,
      cellClass: 'text-right',
      resizable: true
    }, {
      headerName: 'Precio',
      field: 'ProductPrice',
      width: 100,
      cellClass: 'text-right',
      resizable: true,
      cellRenderer: (params: any) => params.value ? `$${Number(params.value).toFixed(2)}` : '$0.00'
    }, {
      headerName: 'Ver',
      field: 'icon',
      width: 80,
      cellRenderer: 'viewChildRendered',
      colId: 'params',
      cellClass: 'text-center'
    }
  ];

  ngOnInit(): void { }

  gridEmiter(GridOptions: GridOptions) {
    this.gridOptions = GridOptions;
    this.getProduct();
  }

  async refresh(){
    this.getProduct();
  }

  view(row: any) {
    window.open('/tax/certifyproduct/' + row.data.ProductCode, '_blank');
  }

  getProduct() {
    const size = this.pageSize === 'Todos' ? 0 : this.pageSize;
    const params: string[] = [];

    if (this.productCode) params.push(`productCode=${this.productCode}`);
    if (this.productName) params.push(`productName=${this.productName}`);

    const queryString = params.length > 0 ? `?${params.join('&')}` : '';

    this.ceqGrid.endPoint = `product/temporal/${this.user.Org}/${size}${queryString}`;
    this.ceqGrid.refreshTable();
  }

  onPageSizeChange(value: any) {
    this.pageSize = value;
    this.getProduct();
  }
}